export const createFormDataFromModel = <TType extends {}>(
  values: TType,
  ignoreNulls?: boolean,
) => {
  const formData = new FormData()
  Object.keys(values).forEach((key: string) => {
    const val = (values as any)[key]
    if (ignoreNulls && val === null) return

    if (Array.isArray(val)) val.forEach((v) => formData.append(`${key}[]`, v))
    else formData.append(key, (values as any)[key])
  })

  return formData
}
